import { useEffect, useState } from "react";

export default function SpeedHistory({ endpoint, portalToken }) {
  const [rows, setRows] = useState([]);
  const [range, setRange] = useState(30);
  const [sel, setSel] = useState(null);
  useEffect(() => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api${endpoint}`;
    fetch(url, portalToken ? { headers: { Authorization: `Bearer ${portalToken}` } } : { credentials: "include" })
      .then((r) => (r.ok ? r.json() : [])).then((d) => setRows(Array.isArray(d) ? d : [])).catch(() => {});
  }, [endpoint, portalToken]);
  if (!rows.length) return null;
  const cutoff = range ? Date.now() - range * 86400000 : 0;
  const filt = rows.filter((r) => !range || (r.at && new Date(r.at).getTime() >= cutoff));
  const max = Math.max(...filt.map((r) => r.download_mbps || 0), 1);
  const shown = filt.slice(0, 30).reverse();
  return (
    <div className="mt-2 rounded-lg border border-slate-700 bg-slate-900/40 p-3" data-testid="speed-history">
      <div className="flex items-center justify-between mb-1.5">
        <div className="text-xs text-slate-400">Historia pomiarów prędkości ({filt.length})</div>
        <div className="flex gap-1">
          {[7, 30, 0].map((d) => (
            <button key={d} onClick={() => setRange(d)} data-testid={`speed-range-${d}`}
              className={`text-[10px] px-2 py-0.5 rounded ${range === d ? "bg-cyan-600 text-white" : "bg-slate-800 text-slate-400"}`}>{d ? `${d} dni` : "wszystko"}</button>
          ))}
        </div>
      </div>
      {shown.length === 0 ? <div className="text-[11px] text-slate-500">Brak pomiarów w tym zakresie.</div> : (
        <div className="flex items-end gap-1 h-16">
          {shown.map((r, i) => (
            <button key={i} type="button" onClick={() => setSel(sel === i ? null : i)} data-testid={`speed-bar-${i}`}
              title={`${r.download_mbps}/${r.upload_mbps} Mb/s · ping ${r.ping_ms} ms · ${(r.at || "").slice(0, 16).replace("T", " ")}`}
              className={`flex-1 rounded-t transition-colors ${sel === i ? "bg-cyan-300" : "bg-cyan-600/70 hover:bg-cyan-400"}`}
              style={{ height: `${Math.max(4, (r.download_mbps || 0) / max * 100)}%` }} />
          ))}
        </div>
      )}
      {sel != null && shown[sel] ? (
        <div className="text-[11px] text-cyan-300 mt-1.5 bg-cyan-950/30 border border-cyan-800/50 rounded px-2 py-1" data-testid="speed-bar-value">
          Wybrany pomiar: <b>{shown[sel].download_mbps}</b> / <b>{shown[sel].upload_mbps}</b> Mb/s · ping <b>{shown[sel].ping_ms}</b> ms · {(shown[sel].at || "").slice(0, 16).replace("T", " ")}
        </div>
      ) : filt[0] && <div className="text-[10px] text-slate-500 mt-1">Ostatni: {filt[0].download_mbps}/{filt[0].upload_mbps} Mb/s · ping {filt[0].ping_ms} ms · {(filt[0].at || "").slice(0, 10)} · <span className="text-slate-600">kliknij słupek, aby zobaczyć wartości</span></div>}
    </div>
  );
}
